module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-192x192-3621dae7724a36f60ecc.png";